import { render, staticRenderFns } from "./TermsTextCh.vue?vue&type=template&id=4fff3908&scoped=true&"
import script from "./TermsTextCh.vue?vue&type=script&lang=js&"
export * from "./TermsTextCh.vue?vue&type=script&lang=js&"
import style0 from "./TermsTextCh.vue?vue&type=style&index=0&id=4fff3908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff3908",
  null
  
)

export default component.exports